import { createBackendContract, buildEventsUrl } from './compat/backendContract';
import { getRuntimeConfig } from '../config/runtimeConfig';

export function createSessionEventSource() {
  const backendContract = createBackendContract(getRuntimeConfig());
  const eventsUrl = buildEventsUrl(backendContract);

  if (!eventsUrl) {
    return null;
  }

  return new EventSource(eventsUrl);
}
